export default __webpack_public_path__ + "static/media/pixellab--og--home.ed8bff25.jpg";